import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({ providedIn: 'root' })
export class ReportService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.CERTIFICADOS}`;

  constructor(private http: HttpClient) {}

  generarCertificadoAfiliacion(body: any): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/afiliaciones`, body, {
      responseType: 'blob',
    });
  }

  generarCertificadoRetefuente(body: any): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/retefuente`, body, {
      responseType: 'blob',
    });
  }
}